import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  loader: {
    width: 55,
  },
  item: {
    padding: 0,
    background: 'transparent',
    flexDirection: 'row',
    gap: 4,
  },
}));

export default useStyles;
